import { enumsPayment } from '@itarget/shared';

export const calculateOfferBusinessRules = ({
  detailing,
  user,
  category,
  annuities,
  totalAnnuity,
  soldOut,
  canBuyMore,
  hasPendingAnnuities,
  collectionFilteredByCampaignId,
  mindsRadiologyUrl,
  freeAccess,
  centerCost
}) => {
  const { STATUS_REGISTRATION } = enumsPayment;

  return {
    // Status da oferta
    status: {
      isSoldOut: soldOut,
      canBuyMore,
      isAvailableForPurchase: !soldOut && canBuyMore,
      maxPurchaseQuantity: detailing?.vagas_limite_insc_mesma_pessoa - detailing?.qtd_inscricoes,
      isCourtesy: detailing?.cortesia === "S",
      hasWaitingList: detailing?.exibe_lista_espera === "S"
    },
    
    // Status do usuário
    userStatus: {
      isRegistered: detailing?.status_inscricao === STATUS_REGISTRATION.REGISTERED,
      hasPendingPayment: detailing?.status_inscricao === STATUS_REGISTRATION.PENDING && detailing?.gerou_cobranca,
      hasShoppingCartPayment: detailing?.status_inscricao === STATUS_REGISTRATION.PENDING && !detailing?.gerou_cobranca,
      hasGeneratedCharge: detailing?.gerou_cobranca !== null,
      canWatchContent: detailing?.status_inscricao === STATUS_REGISTRATION.REGISTERED,
      canUseCashback: detailing?.status_inscricao !== STATUS_REGISTRATION.REGISTERED,
      hasAdherenceTerms: collectionFilteredByCampaignId.some(
        (campaign) => !campaign.adesoes_clientes_campanhas_aceite
      ) && (!detailing?.status_inscricao || canBuyMore)
    },
    
    // Conteúdo disponível
    content: {
      hasReleasedContent: detailing?.qtde_aulas_video > 0 || detailing?.disponivel_transmissao === "S",
      hasTransmission: detailing?.disponivel_transmissao === "S",
      hasClasses: detailing?.qtde_aulas_video > 0,
      hasMindsRadiology: detailing?.status_inscricao === STATUS_REGISTRATION.REGISTERED && !!mindsRadiologyUrl
    },
    
    // Valores e categorias
    values: {
      hasComboAnnuity: (!detailing?.status_inscricao || canBuyMore) && 
                       detailing?.qtde_anuidade_pendente > 0 && 
                       detailing?.cortesia !== "S" && 
                       !soldOut && 
                       hasPendingAnnuities,
      hasDiscountedComboAnnuity: (!detailing?.status_inscricao || canBuyMore) && 
                                !!totalAnnuity && 
                                detailing?.cortesia !== "S" && 
                                !soldOut,
      hasTotalAmount: ((!detailing?.status_inscricao && 
                       detailing?.qtde_anuidade_pendente > 0 && 
                       hasPendingAnnuities) || 
                       canBuyMore) && 
                      detailing?.cortesia !== "S" && 
                      !soldOut && 
                      !!detailing?.plp_id,
      hasReference: user?.data?.id && 
                   ![STATUS_REGISTRATION.REGISTERED].includes(detailing?.status_inscricao) && 
                   detailing?.cortesia !== "S"
    }
  };
}; 